import { ChangeEventHandler } from 'react';
import { Profile } from 'models';
import { TextField } from '@mui/material';
import { Form } from './EditProfileForm.styles';

interface EditProfileFormProps {
  profile: Profile;
  isInvalidEmail: boolean;
  onChange: ChangeEventHandler<HTMLInputElement>;
}

const EditProfileForm = ({ profile, isInvalidEmail, onChange }: EditProfileFormProps) => {
  const { firstName, lastName, email, canEdit } = profile;

  const inputs = [
    {
      name: 'firstName',
      label: 'First name',
      defaultValue: firstName,
    },
    {
      name: 'lastName',
      label: 'Last name',
      defaultValue: lastName,
    },
    {
      name: 'email',
      label: 'Email',
      defaultValue: email,
    },
  ];

  return (
    <Form>
      {inputs.map((input) => (
        <TextField
          key={input.name}
          {...input}
          variant="filled"
          disabled={!canEdit}
          onChange={onChange}
          aria-label="Profile input"
          error={input.name === 'email' && isInvalidEmail}
          helperText={input.name === 'email' && isInvalidEmail ? 'Not a valid email address' : ''}
        />
      ))}
    </Form>
  );
};

export default EditProfileForm;
